import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function EventsIcon({
	width = 20,
	height = 20,
	color = 'currentColor',
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', ...style }}
			{...rest}
		>
			<path
				d="M19.9995 5.35927V6.59698H0V5.35927C0 3.73895 1.32189 2.42334 2.95013 2.42334H3.56885V3.99696C3.56885 4.90211 4.30939 5.63913 5.21887 5.63913C6.12835 5.63913 6.86889 4.90211 6.86889 3.99696V2.42334H13.1313V3.99696C13.1313 4.90211 13.8718 5.63913 14.7813 5.63913C15.6908 5.63913 16.4313 4.90211 16.4313 3.99696V2.42334H17.05C18.6813 2.42334 20 3.73895 20 5.35927H19.9996H19.9995Z"
				fill={color}
			/>
			<path
				d="M6.24322 1.02006V3.99635C6.24322 4.55978 5.78441 5.01641 5.21829 5.01641C4.65217 5.01641 4.19336 4.55978 4.19336 3.99635V1.02006C4.19336 0.45663 4.65217 0 5.21829 0C5.78441 0 6.24322 0.45663 6.24322 1.02006Z"
				fill={color}
			/>
			<path
				d="M15.8057 1.02006V3.99635C15.8057 4.55978 15.3469 5.01641 14.7808 5.01641C14.2147 5.01641 13.7559 4.55978 13.7559 3.99635V1.02006C13.7559 0.45663 14.2147 0 14.7808 0C15.3469 0 15.8057 0.45663 15.8057 1.02006Z"
				fill={color}
			/>
			<path
				d="M0 7.21777V17.0673C0 18.6876 1.32189 20.0001 2.94996 20.0001H17.0495C18.6808 20.0001 19.9995 18.6876 19.9995 17.0673V7.21777H0ZM6.28949 12.0084C6.28949 12.3859 5.9819 12.692 5.6026 12.692H3.29207C2.91277 12.692 2.60519 12.3859 2.60519 12.0084V9.70571C2.60519 9.32821 2.91277 9.02209 3.29207 9.02209H5.6026C5.9819 9.02209 6.28949 9.32821 6.28949 9.70571V12.0084ZM11.8418 12.0084C11.8418 12.3859 11.5342 12.692 11.1549 12.692H8.84438C8.4649 12.692 8.15749 12.3859 8.15749 12.0084V9.70571C8.15749 9.32821 8.46508 9.02209 8.84438 9.02209H11.1549C11.5342 9.02209 11.8418 9.32821 11.8418 9.70571V12.0084ZM17.3941 12.0084C17.3941 12.3859 17.0865 12.692 16.7072 12.692H14.3967C14.0174 12.692 13.7098 12.3859 13.7098 12.0084V9.70571C13.7098 9.32821 14.0174 9.02209 14.3967 9.02209H16.7072C17.0865 9.02209 17.3941 9.32821 17.3941 9.70571V12.0084Z"
				fill={color}
			/>
		</svg>
	);
}
